import { Carousel } from "antd"
import "./carousel.scss"

export default Carousel
